import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      familyInformation: 'Family Information',
      students: 'Students',
      student: 'Student',
      instructor: 'Instructor',
      age: 'Age',
      years: 'years',
      currentCourses: 'Current Courses',
      teacher: 'Teacher',
      schedule: 'Schedule',
      backToList: 'Back to Students List',
      studentInformation: 'Student Information',
      attendance: 'Attendance',
      contactUs: 'Contact Us',
      logout: 'Sign out'
    }
  },
  so: {
    translation: {
      familyInformation: 'Macluumaadka Qoyska',
      students: 'Ardayda',
      student: 'Arday',
      instructor: 'Macalinka',
      age: 'Da\'da',
      years: 'sano',
      currentCourses: 'Casharada Hadda',
      teacher: 'Macalinka',
      schedule: 'Jadwalka',
      backToList: 'Ku noqo Liiska Ardayda',
      studentInformation: 'Macluumaadka Ardayga',
      attendance: 'Imaanshaha',
      contactUs: 'Nala soo xidhiidh',
      logout: 'Ka bax'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;